module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "main-id",
    class: ['main', _vm.activePanel],
    attrs: {
      "id": "main-id"
    }
  }, [_c('div', {
    staticClass: "row inherit"
  }, [_c('sidebar'), _vm._v(" "), _c('router-view', {
    key: _vm.$store.state.route.meta.type || _vm.$store.state.route.name
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-overlay",
    on: {
      "click": _vm.hidePanel
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f05beb5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash.vue
// module id = bN63
// module chunks = 1